<div class="main-db gap-top">

  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-12">
        <div class="db-block" style="height: auto !important;">
          <div class="w-100 float-left">
            <div class="float-left">
              <h1>
                <i class="fa fa-clock mr-1" aria-hidden="true"></i>{{title}}</h1>
            </div>
            
            <a
            type="button"
            class="float-right mr-3"
            (click)="excelSheetDownload()"
          >
            <i class="fa fa-file-excel mr-1" aria-hidden="true"></i> Export CSV
          </a>
          </div>
          <div class="w-100 float-left row">
            
            <div class="form-group p-1 pl-2 col-sm-2 col-4 float-left">
              <label>User</label>
              <select class="form-control form-control-sm input-custom" [(ngModel)]="userFilter" aria-placeholder="Select">
                <!-- <option *ngIf="uniqueArrayLength < 2" [disabled]="true" value="">Select Patrolling Officer</option> -->
                <option *ngIf="uniqueArrayLength > 1" value="0">All</option>
                <option *ngFor="let user of userList" value="{{user.userId}}">{{user.firstName}}</option>
              </select>
            </div>

            <!-- <div class="form-group p-1 col-sm-2 col-4 float-left">
              <label>Start Date</label>
              <input class="form-control" type="date" [(max)]="endDateFilter" [(ngModel)]="startDateFilter" (ngModelChange)="startDateFilter = $event">
            </div>

            <div class="form-group p-1 col-sm-2 col-4 float-left">
              <label>End Date</label>
              <input class="form-control" type="date" [(min)]="startDateFilter" [(ngModel)]="endDateFilter" (ngModelChange)="endDateFilter = $event">
            </div> -->

            <div class="col-sm-4 col-8 float-left form-group p-1">
              <label>Select Date Range</label>
              <input type="text" matInput
                class="form-control form-control-sm  input-custom pl-2 mt-0"
                ngxDaterangepickerMd
                [locale]="{format: 'YYYY-MM-DD'}"
                startKey="start"
                endKey="end"
                [(ngModel)]="selected"
                [showCustomRangeLabel]="true"
                [alwaysShowCalendars]="true"
                [ranges]="ranges"
                [linkedCalendars]="true"
                name="daterange"/>
            </div>

            <div class="form-group p-1 col-sm-4 col-6 float-left">
              <label class="d-none d-sm-inline" style="visibility: hidden;">Search</label>
              <input type="text" class="form-control form-control-sm input-custom" placeholder="Search" [(ngModel)]="search"/>
            </div>

            <div class="form-group p-1 col-sm-1 col-3 float-left">
              <label class="d-none d-sm-inline" style="visibility: hidden;">Search</label>
              <input class="btn btn-sm btn-success w-100" type="button" (click)="getFilterData()" value="Search"/>
            </div>

            <div class="form-group p-1 col-sm-1 col-3 float-left">
              <label class="d-none d-sm-inline" style="visibility: hidden;">Clear</label>
              <input class="btn btn-sm btn-danger w-100" type="reset" (click)="clear()" value="Clear"/>
            </div>
          </div>
          <div class="mt-4">
                <div class="table-responsive db-block" style="min-height: 50vh; height: auto !important;">
                  <table mat-table [dataSource]="dataSource" class="gridData mt-2" multiTemplateDataRows matSort>
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                      <td mat-cell *matCellDef="let element">     
                        <span>
                          <span (click)="toggleOn(element)" class="noselect" role="button" *ngIf="element.expanded == null && expandAll == false || element.expanded == false && expandAll == false"> <i class="fa fa-plus"></i> </span>
                          <span (click)="toggleOn(element)" class="noselect" role="button" *ngIf="element.expanded == true && expandAll == false || expandAll == true"> <i class="fa fa-minus"></i> </span>
                        </span>
                     </td>
                    </ng-container>
                    <ng-container matColumnDef="userName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                      <td mat-cell *matCellDef="let element"> {{element.userName}} </td>
                    </ng-container>
            
                    <ng-container matColumnDef="sessionStart">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Shift Start</th>
                      <td mat-cell *matCellDef="let element"> {{element.sessionStart | date:'y-MM-dd HH:mm:ss.SSS'}} </td>
                    </ng-container>
            
                    <ng-container matColumnDef="sessionEnd">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Shift End </th>
                      <td mat-cell *matCellDef="let element"> {{element.sessionEnd | date:'y-MM-dd HH:mm:ss.SSS'}} </td>
                    </ng-container>
            
                    <ng-container matColumnDef="duration">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration</th>
                      <td mat-cell *matCellDef="let element"> {{element.duration}} </td>
                    </ng-container>
            
                    <ng-container matColumnDef="cameraGroupName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Camera Group</th>
                      <td mat-cell *matCellDef="let element"> {{element.cameraGroupName}} </td>
                    </ng-container>
            
                    <ng-container matColumnDef="totalScans">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Scans</th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.data != null">{{element.data.length}}</span>
                        <span *ngIf="element.data == null">0</span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="totalPermitted">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Permitted</th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.data != null">{{PermittedCount(element)}}</span>
                        <span *ngIf="element.data == null">0</span>
                      </td>
                    </ng-container>
            
                    <ng-container matColumnDef="totalAuthorized">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Authorized</th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.data != null">{{AuthCount(element)}}</span>
                        <span *ngIf="element.data == null">0</span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="totalExpired">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Expired</th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.data != null">{{ExpiredCount(element)}}</span>
                        <span *ngIf="element.data == null">0</span>
                      </td>
                    </ng-container>
            
                    <ng-container matColumnDef="totalUnAuthorized">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Unauthorized</th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.data != null">{{UnauthCount(element)}}</span>
                        <span *ngIf="element.data == null">0</span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="totalUnpaid">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Unpaid</th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.data != null">{{UnpaidCount(element)}}</span>
                        <span *ngIf="element.data == null">0</span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="download">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                      <td mat-cell *matCellDef="let element">
                          <mat-icon *ngIf="element.data != null" style="cursor: pointer;" class="text-warning" (click)="excelSheetDetailDownload(element)">cloud_download</mat-icon>
                          <mat-icon *ngIf="element.data == null" style="cursor: not-allowed;">cloud_download</mat-icon>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="expandedDetail">
                      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                        <div class="example-element-detail"
                            [@detailExpand]="element.expanded ? 'expanded' : 'collapsed'">
                            <div class="table-responsive db-block" style="height: auto !important;">
                            <table class="table table-sm mat-table gridData mt-2">
                              <thead>
                                <tr>
                                  <th (click)="sortTable(0)">License Plate</th>
                                  <th>State</th>
                                  <th (click)="sortTable(2)">Scanned on</th>
                                  <th (click)="sortTable(3)">Search Detail</th>
                                  <th (click)="sortTable(4)">Camera</th>
                                  <th>View Details</th>
                                </tr>
                              </thead>
                              <tbody *ngIf="element.data == null">
                                <tr class="mat-row">
                                  <td colspan="6" style="text-align: center;">No Data Found</td>
                                </tr>
                              </tbody>
                              <tbody *ngIf="element.data != null">
                                <tr class="mat-row" *ngFor="let detailrow of element.data | filter:search">
                                  <td class="mat-cell">{{detailrow.licenceNumber}}</td>
                                  <td class="mat-cell">{{detailrow.state}}</td>
                                  <td class="mat-cell">{{detailrow.createdDate | date:'y-MM-dd HH:mm:ss'}}</td>
                                  <td class="mat-cell">
                                    {{detailrow.matchedStatus}}
                                    <!-- <span *ngIf="detailrow.matchedStatus == 'Not matched'">Not Matched</span>
                                    <span *ngIf="detailrow.matchedListType == 'Full Match' && detailrow.matchedStatus == 'Hitlist'">Target Detected</span>
                                    <span *ngIf="detailrow.matchedListType == 'Partial Match' && detailrow.matchedStatus == 'Hitlist'">Potential Target Detected Matched with {{detailrow.partialMatchLicenceNumber}}</span> -->
                                  </td>
                                  <td class="mat-cell">{{detailrow.cameraIdentifier}}</td>
                                  <td class="mat-cell">
                                    <button mat-icon-button matTooltip="Click to View Details" class="iconbutton text-warning float-left">
                                      <mat-icon aria-label="View" (click)="viewDetail(detailrow)">remove_red_eye</mat-icon>
                                    </button>
                                    <!-- <button *ngIf="detailrow.matchedStatus == 'Unpaid' || detailrow.matchedStatus == 'Expired'" mat-icon-button matTooltip="Click to View Email" class="iconbutton text-warning float-left">
                                      <mat-icon aria-label="PDF" (click)="downloadPDF(detailrow)">cloud_download</mat-icon>
                                    </button> -->
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                            
                          </div>
                      </td>
                    </ng-container>
            
                    <!-- <ng-container matColumnDef="totalHits">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Hits</th>
                      <td mat-cell *matCellDef="let element"> {{Count(element)}} </td>
                    </ng-container> -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"
          class="example-element-row"
          [class.example-expanded-row]="element.expanded"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
      </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>
          <!-- <div class="mt-4">
            <div class="table-responsive" style="height: 55vh;">
              <div class="mat-elevation-z0">
                <table class="table table-sm table-responsive-lg table-bordered table-striped table-hover">
                  <thead>
                  <tr>
                    <th>Action</th> -->
                    <!-- <th>Shift ID
                    </th> -->
                      <!-- <mat-icon *ngIf="dir == 'desc'" style="font-size: 17px; position: absolute;">arrow_downward</mat-icon>
                      <mat-icon *ngIf="dir == 'asc'" style="font-size: 17px; position: absolute;">arrow_upward</mat-icon> -->
                    <!-- <th>Name</th>
                    <th>Shift Started</th>
                    <th>Shift Ended</th>
                    <th>Duration</th>
                    <th>Camera Group</th>
                    <th>Total Scans</th>
                    <th>Total Hits</th>
                  </tr>
                  </thead>
                  <tbody *ngIf="mydata.length == 0">
                    <tr>
                      <td colspan="8" style="text-align: center;">No Data Found</td>
                    </tr>
                  </tbody>
                  <tbody *ngFor="let row of mydata | filter:search">
                  <tr>
                    <td>
                      <span>
                        <a class="noselect" *ngIf="row.expanded == null && expandAll == false || row.expanded == false && expandAll == false" (click)="toggleOn(row)"> <i class="fa fa-plus"></i> </a>
                        <a class="noselect" *ngIf="row.expanded == true && expandAll == false || expandAll == true" (click)="toggleOff(row)"> <i class="fa fa-minus"></i> </a>
                      </span>
                    </td> -->
                    <!-- <td>{{row.id}}</td> -->
                    <!-- <td>{{row.userName}}</td>
                    <td>{{row.sessionStart | date:'y-MM-dd HH:mm:ss.SSS'}}</td>
                    <td>{{row.sessionEnd | date:'y-MM-dd HH:mm:ss.SSS'}}</td>
                    <td>{{row.duration}}</td>
                    <td>{{row.cameraGroupName}}</td>
                    <td *ngIf="row.data != null; else noscan">{{row.data.length}}</td>
                    <ng-template #noscan>
                      <td>0</td>
                    </ng-template>
                    <td>
                      {{Count(row)}}
                    </td>
                  </tr>
                    <td colspan="12" *ngIf="row.expanded == true || expandAll == true">
                      <div class="arrow-show">
                      </div>
                      <div class="mx-5">
                        
                        <button type="button" class="btn btn-sm btn-success float-right ml-2" (click)="excelSheetDetailDownload(row)">
                          <i class="fa fa-file-excel mr-1" aria-hidden="true"></i> Export CSV
                        </button>

                        <table class="table table-sm table-responsive-lg table-bordered table-striped table-hover"  id="myTable">
                          <thead>
                          <tr>
                            <th (click)="sortTable(0)">License Plate</th>
                            <th>State</th>
                            <th (click)="sortTable(2)">Scanned on</th>
                            <th (click)="sortTable(3)">Search Detail</th>
                            <th (click)="sortTable(4)">Camera</th>
                            <th>View Details</th>
                          </tr>
                          </thead>
                          
                          <tbody *ngIf="row.data == null">
                            <tr>
                              <td colspan="6" style="text-align: center;">No Data Found</td>
                            </tr>
                          </tbody>
                          <tbody *ngFor="let detailrow of row.data | filter:search" >
                          <tr>
                            <td>{{detailrow.licenceNumber}}</td>
                            <td>{{detailrow.state}}</td>
                            <td>{{detailrow.createdDate | date:'y-MM-dd HH:mm:ss'}}</td>
                            <td>
                              <span *ngIf="detailrow.matchedStatus == 'Not matched'">Not Matched</span>
                              <span *ngIf="detailrow.matchedListType == 'Full Match' && detailrow.matchedStatus == 'Hitlist'">Target Detected</span>
                              <span *ngIf="detailrow.matchedListType == 'Partial Match' && detailrow.matchedStatus == 'Hitlist'">Potential Target Detected Matched with {{detailrow.partialMatchLicenceNumber}}</span>
                            </td>
                            <td>{{detailrow.cameraIdentifier}}</td>
                            <td>
                              <button mat-icon-button matTooltip="Click to View Details" class="iconbutton text-warning float-left">
                                <mat-icon aria-label="View" (click)="viewDetail(detailrow)">remove_red_eye</mat-icon>
                              </button>
                              <button *ngIf="detailrow.matchedStatus == 'Unpaid' || detailrow.matchedStatus == 'Expired'" mat-icon-button matTooltip="Click to View Email" class="iconbutton text-warning float-left">
                                <mat-icon aria-label="PDF" (click)="downloadPDF(detailrow)">cloud_download</mat-icon>
                              </button>
                            </td> -->
                            <!-- <td>
                              <a type="button" class="mr-2" (click)="getImg(detailrow)" data-toggle="modal" data-target="#viewPrompt">
                                <i class="fas fa-eye"></i>
                              </a>
                              <a href="{{detailrow.image}}" download="{{detailrow.LicensePlate}}">
                                <i class="fa fa-download"></i>
                              </a>
                              <div class="modal fade" id="viewPrompt" tabindex="-1" role="dialog" aria-labelledby="viewPromptLabel" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                  <div class="modal-content">
                                    <div class="modal-header">
                                      <h5 class="modal-title orange-text" id="viewPromptLabel">View Email {{lpr}}</h5>
                                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                    <div class="modal-body">
                                      <img [src]="getEmail(eImg)" class="w-100"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td> -->
                          <!-- </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tbody>
                </table>
            </div>
          </div>
        </div> -->
        <!-- <div class="row mt-3">
          <div class="col-xl-8">
            <mat-paginator [pageSizeOptions]="[10, 25]"></mat-paginator>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
</div>
